export const layoutInteractionType = {

    SET_ACTIONS: "SET_ACTIONS",

    SET_HEADER_TITLE: "SET_HEADER_TITLE",

    CHANGE_COLLAPSED_SIDER: "CHANGE_COLLAPSED_SIDER",

    CHANGE_SEARCH: "CHANGE_SEARCH",

    ON_CLICK_FILTER: "ON_CLICK_FILTER",

    SET_FILER_MENU: "SET_FILER_MENU",

    SET_HEADER: "SET_HEADER",

    ON_CHANGE_VISIBLE_DRAWER: "ON_CHANGE_VISIBLE_DRAWER",

    ON_CHANGE_VISIBLE_MODAL: "ON_CHANGE_VISIBLE_MODAL",

    ON_RELOAD_DATA: "ON_RELOAD_DATA",

    ON_UPDATE_CLICK: "ON_UPDATE_CLICK",

    ON_PAGINATION_CHANGE: "ON_PAGINATION_CHANGE",

    ON_SORTER_CHANGE: "ON_SORTER_CHANGE",

    ON_CHANGE_SUCCESS_AXIOS: "ON_CHANGE_SUCCESS_AXIOS",

    ON_CHANGE_OBJECT: "ON_CHANGE_OBJECT",

    ON_PAGINATION_SORT_CHANGE: "ON_PAGINATION_SORT_CHANGE",

    ON_CHANGE_REPEAT_TEXT: "ON_CHANGE_REPEAT_TEXT",

    ON_CHANGE_SCREEN_WIDTH: "ON_CHANGE_SCREEN_WIDTH",
    CHECK_ADMIN: "CHECK_ADMIN",

    CHANGE_SETTING_SIDER: "CHANGE_SETTING_SIDER",

    ACCOUNT : "ACCOUNT",
    WEIGHING_STATION : "WEIGHING_STATION",
    ON_CHANGE_VISIBLE_DRAWER_ADMIN: "ON_CHANGE_VISIBLE_DRAWER_ADMIN",

}
